import ClientError from '../client-error';
import errors from 'src/static/errors.json';

export default class BadRequestError extends ClientError {
  public static status = 400;
  public name = 'BadRequestError';
  constructor(message: string = errors.genericError) {
    super(message);
  }
}
